import _createForOfIteratorHelper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var canUseDOM = function canUseDOM() {
  return !(typeof window === "undefined" || window.document === undefined || window.document.createElement === undefined);
};
export var combineRefs = function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (instance) {
    var _iterator = _createForOfIteratorHelper(refs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (item === null || item === undefined) {
          continue;
        }

        if (typeof item === "object") {
          item.current = instance;
        } else {
          item(instance);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};
export var noop = function noop() {};